import { render } from "./EditorEmbed.vue?vue&type=template&id=270832d5"
import script from "./EditorEmbed.vue?vue&type=script&lang=js"
export * from "./EditorEmbed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__